import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";


export class Errormsg {
    show = false;
    text = '';
    // crewName: string | null | undefined = "";
    delay = 3000;
    error = "msg";

    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);

        this.rootStore = rootStore;
    }

    // showNotification(text: string, crew: string | null | undefined, delay: number) {
    //     this.show = true;
    //     this.text = text;
    //     this.crewName = crew;
    //     this.delay = delay;
    //   }
      errorNotification(error: string, text: string, delay: number): void {
        this.error = 'msg';
        this.show = true;
        this.text = text;
        this.delay = delay;

      }
    resetNotification() {
    this.show = false;
    }

    handleShow = (a: boolean) =>  {
        this.show = a;
    }

    get getShow() {
        return this.show;
    }
    get getText() {
        return this.text;
    }
    get getError() {
        return this.error;
    }
}